import React from 'react';

const SvgIcHome = (props) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg" width="15.639" height="14.595" viewBox="0 0 15.639 14.595">
  <path id="Home_SVG" data-name="Home SVG" d="M16.562,9.584a1.155,1.155,0,0,1-1.089.757h-.4v5.734a.521.521,0,0,1-.521.521H11.425V12.947a2.606,2.606,0,0,0-5.213,0V16.6H3.085a.521.521,0,0,1-.521-.521V10.341h-.4A1.167,1.167,0,0,1,1.4,8.3L7.486,2.532a1.938,1.938,0,0,1,2.665,0l6.1,5.779A1.149,1.149,0,0,1,16.562,9.584Z" transform="translate(-0.999 -2.001)"/>
</svg>
);

export default SvgIcHome;
